module.exports = "https://www.gc-pro.gnp.com.mx/e4c8472c43a87993cbe2b0920ab10785.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/capitaliza/4.png
// module id = 1016
// module chunks = 0 1